import React from 'react';
import './product-availability.css';
import { useIntl } from 'react-intl';
import ProductAvailabilityElement from './product-availability-element';
import { IProductAvailabilityItem } from '../../../../../../../Application/TypewriterModels/IProductAvailabilityItem';
import { useProductAvailability } from '../../../hooks/use-product-availability';
import { ISession } from '../../../models/pro-sites';
import { RootState } from '../../../store';
import { connect } from 'react-redux';
import { MONTHS_FRENCH_CAPITAL, US } from '../../common/constants';
import moment from 'moment';
interface IProductAvailabilityTableProps {
    session: ISession | null;
    productAvailabilityData: IProductAvailabilityItem[];
    lastUpdated: string;
}
const ProductAvailabilityTable: React.FC<IProductAvailabilityTableProps> = ({
    session,
    productAvailabilityData,
    lastUpdated,
}) => {
    const intl = useIntl();
    const categories = useProductAvailability(productAvailabilityData);
    const getDatetimeString = (datetime: string): string | undefined => {
        if (datetime) {
            if (session!.country === US) {
                return moment(datetime).format('MMMM D, YYYY');
            } else {
                moment.updateLocale('fr', { months: MONTHS_FRENCH_CAPITAL });
                return moment(datetime).locale('fr').format('D MMMM YYYY');
            }
        }
    };
    const filterCategory = (category: string): JSX.Element[] => {
        return productAvailabilityData
            .filter((item) => item.category === category)
            .map((item, index) => {
                return (
                    <ProductAvailabilityElement
                        key={index}
                        product={item.product}
                        availability={item.availability}
                        availabilityEng={item.availabilityEng}
                        latestUpdate={item.latestUpdate}
                        category={item.category}
                    />
                );
            });
    };

    return (
        <>
            <div className="product-availability-header">
                <div className="last-updated-sign">
                    {intl.formatMessage({
                        id: 'Updated',
                        defaultMessage: 'Updated',
                    })}
                </div>
                <div className="last-updated-date">
                    {getDatetimeString(lastUpdated)}
                </div>
            </div>
            <div className="product-availability-header">
                <div className="header-item-product">
                    {intl.formatMessage({
                        id: 'Product-home',
                        defaultMessage: 'Product',
                    })}
                </div>
                <div className="header-item-availability">
                    {intl.formatMessage({
                        id: 'Availability',
                        defaultMessage: 'Availability',
                    })}
                </div>
                <div className="header-item-latest-update">
                    {intl.formatMessage({
                        id: 'Latest_Updates',
                        defaultMessage: 'Latest Updates',
                    })}
                </div>
            </div>
            <div className="product-availability-table">
                {productAvailabilityData &&
                    categories.map((category, index) => {
                        return (
                            <div key={index}>
                                <div className="product-availability-subheader">
                                    {category}
                                </div>
                                {filterCategory(category)}
                            </div>
                        );
                    })}
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        session: state.session ? state.session.data! : null,
    };
};
const productAvailabilityTableContainer = connect(mapStateToProps)(
    ProductAvailabilityTable
);

export default productAvailabilityTableContainer;
